// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
._fadeTransition_LwZI- {
	transition: all var(--animation-quick) ease;
}
._fadeTransitionActive_hJxV5 {
	opacity: 0;
	position: absolute;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcBlurHash-Zj5Z9WKv.css"],"names":[],"mappings":";AACA;CACC,2CAA2C;AAC5C;AACA;CACC,UAAU;CACV,kBAAkB;AACnB","sourcesContent":["\n._fadeTransition_LwZI- {\n\ttransition: all var(--animation-quick) ease;\n}\n._fadeTransitionActive_hJxV5 {\n\topacity: 0;\n\tposition: absolute;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
